import React from 'react';
import { Navigate } from 'react-router-dom';
import NoAccess from 'src/components/NoAccess/NoAccess';
import { useAuth } from 'src/features/authorization';

const ProjectsSwitcher: React.FC = () => {
  const { checkAccess } = useAuth();

  if (checkAccess('DevelopmentProject').read) {
    return <Navigate to="in-projects" replace />;
  }

  if (checkAccess('PortalProject').read) {
    return <Navigate to="own-projects" replace />;
  }

  return <NoAccess />;
};

export default ProjectsSwitcher;
